import React, { createContext, useContext, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { AlertTriangle } from "lucide-react";

const Ctx = createContext(null);
export const useConfirm = () => useContext(Ctx);

export function ConfirmProvider({ children }) {
  const [opts, setOpts] = useState(null);

  const confirm = useCallback((options) => new Promise((resolve) => {
    setOpts({ ...options, _resolve: resolve });
  }), []);

  const close = (val) => {
    if (opts?._resolve) opts._resolve(val);
    setOpts(null);
  };

  return (
    <Ctx.Provider value={confirm}>
      {children}
      <Dialog open={!!opts} onOpenChange={(o) => !o && close(false)}>
        <DialogContent data-testid="confirm-dialog">
          <DialogHeader>
            <DialogTitle className={`flex items-center gap-2 ${opts?.tone === "danger" ? "text-red-700" : opts?.tone === "warn" ? "text-amber-700" : "text-sky-800"}`}>
              {opts?.tone !== "info" && <AlertTriangle className="w-5 h-5" />}
              {opts?.title || "Confirmation"}
            </DialogTitle>
            <DialogDescription className="text-slate-700 pt-2 whitespace-pre-line">
              {opts?.body}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex gap-2">
            <Button variant="outline" className="rounded-full" onClick={() => close(false)} data-testid="confirm-cancel">
              {opts?.cancelLabel || "Annuler"}
            </Button>
            <Button
              className={`rounded-full ${opts?.tone === "danger" ? "bg-red-600 hover:bg-red-700" : opts?.tone === "warn" ? "bg-amber-600 hover:bg-amber-700" : "bg-sky-700 hover:bg-sky-600"}`}
              onClick={() => close(true)}
              data-testid="confirm-ok"
            >
              {opts?.confirmLabel || "Valider"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
}
